'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loggingUtil = require('../../../utils/logging-util');

var _services = require('../../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _urls = require('../../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _hudlCoreComponents = require('hudl-core-components');

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

var _logValues = require('../../../shared/logging/log-values');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultLogData = _defineProperty({}, _logValues.ORIGIN_KEY, _logValues.CARD_TAG_MODAL);

var TagSummary = function (_PureComponent) {
  _inherits(TagSummary, _PureComponent);

  function TagSummary(props) {
    _classCallCheck(this, TagSummary);

    var _this = _possibleConstructorReturn(this, (TagSummary.__proto__ || Object.getPrototypeOf(TagSummary)).call(this, props));

    _this.logProfileClick = function () {
      var logData = _this.props.logData || {};
      var videoHasTags = !!_this.props.totalTaggedUsers;
      var combinedData = Object.assign({}, logData, {
        contentId: _this.props.feedContentId,
        videoHasTags: videoHasTags,
        origin: 'CardTags'
      });
      if (_this.props.feedContentId) {
        return _services2.default.logProfileClick(combinedData);
      }
      return null;
    };

    _this.openUserProfile = _this.openMiniProfile.bind(_this, props.currentUserId);
    _this.openOtherUserProfile = _this.openMiniProfile.bind(_this, props.otherUserId);
    _this.initLogData(props);
    return _this;
  }

  _createClass(TagSummary, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initLogData(nextProps);
    }
  }, {
    key: 'initLogData',
    value: function initLogData(newProps) {
      this.ownLogData = (0, _loggingUtil.copyLogData)(this.ownLogData, newProps.logData, defaultLogData);
    }
  }, {
    key: 'openMiniProfile',
    value: function openMiniProfile(userId) {
      this.logProfileClick();
      this.props.openMiniProfile(userId);
    }
  }, {
    key: 'navigateToProfile',
    value: function navigateToProfile(url) {
      var log = this.logProfileClick();
      if (log) {
        log.done(function () {
          return window.location.href = url;
        }).fail(function () {
          return window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      return _react2.default.createElement(
        'ul',
        { className: 'tagged-users__tooltip' },
        this.props.topTaggedFeedUsers.map(function (feedUser) {
          var name = _feedUserUtil2.default.getFeedUserName(feedUser);
          var profileUrl = _urls2.default.getFeedUserProfileUrl(feedUser.feedUserId.type, feedUser.feedUserId.relatedId);
          return _react2.default.createElement(
            'li',
            { key: feedUser.feedUserId.type + '__' + feedUser.feedUserId.relatedId },
            _react2.default.createElement(
              'a',
              { href: profileUrl, target: '_blank' },
              name
            )
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      // If no users are tagged, we don't want to display anything
      if (!this.props.totalTaggedUsers) {
        return _react2.default.createElement('span', null);
      }

      // Only display other user if both pieces of information provided
      var otherUserIsTagged = !!(this.props.otherUserName && this.props.otherUserProfileUrl);

      // Only use commas if format is you, Other User, and X other[s]
      // Otherwise just:
      // [you|Other User] [and X other[s]]
      // OR
      // you and Other User
      var commasNeeded = this.props.currentUserIsTagged && otherUserIsTagged && this.props.totalTaggedUsers > 2;

      var linkList = ['— with '];
      if (this.props.currentUserIsTagged) {
        if (this.props.miniProfileEnabled) {
          linkList.push(_react2.default.createElement(
            'a',
            { key: 'current-user',
              onClick: this.openUserProfile,
              target: '_blank' },
            'you'
          ));
        } else {
          linkList.push(_react2.default.createElement(
            'a',
            { key: 'current-user',
              onClick: this.logProfileClick,
              href: this.props.currentUserProfileUrl,
              target: '_blank' },
            'you'
          ));
        }
        if (commasNeeded) {
          linkList.push(', ');
        } else if (this.props.totalTaggedUsers > 1) {
          linkList.push(' and ');
        }
      }

      if (otherUserIsTagged) {
        if (this.props.miniProfileEnabled) {
          linkList.push(_react2.default.createElement(
            'a',
            { key: 'other-user',
              target: '_blank',
              onClick: this.openOtherUserProfile },
            this.props.otherUserName
          ));
        } else {
          linkList.push(_react2.default.createElement(
            'a',
            { key: 'other-user',
              target: '_blank',
              onClick: this.logProfileClick,
              href: this.props.otherUserProfileUrl },
            this.props.otherUserName
          ));
        }
        if (commasNeeded) {
          linkList.push(', and ');
        } else if (this.props.totalTaggedUsers > 2 || this.props.totalTaggedUsers === 2 && !this.props.currentUserIsTagged) {
          linkList.push(' and ');
        }
      }

      var otherCount = this.props.totalTaggedUsers;
      otherCount -= this.props.currentUserIsTagged ? 1 : 0;
      otherCount -= otherUserIsTagged ? 1 : 0;

      if (otherCount > 0) {
        var otherCountText = _react2.default.createElement(
          'a',
          { key: 'others',
            onClick: this.props.showOthers,
            target: '_blank',
            className: 'tag-summary__others' },
          otherCount,
          ' other',
          otherCount > 1 ? 's' : ''
        );

        var otherCountComponent = this.props.taggedUsersModalEnabled ? otherCountText : _react2.default.createElement(
          _hudlCoreComponents.Tooltip,
          {
            env: 'dark',
            position: 'top',
            style: { display: 'inline', zIndex: 100 },
            text: this.renderTooltip() },
          otherCountText
        );

        linkList.push(otherCountComponent);
      }

      return _react2.default.createElement(
        'span',
        null,
        linkList
      );
    }
  }]);

  return TagSummary;
}(_react.PureComponent);

TagSummary.propTypes = {
  feedContentId: _react.PropTypes.string,
  communityContentIdObject: spt.CommunityContentId.isRequired,
  currentUserIsTagged: _react.PropTypes.bool,
  currentUserProfileUrl: _react.PropTypes.string,
  currentUserId: _react.PropTypes.shape({
    type: _react.PropTypes.number.isRequired,
    relatedId: _react.PropTypes.string.isRequired
  }),
  logData: _react.PropTypes.object.isRequired,
  otherUserName: _react.PropTypes.string,
  otherUserProfileUrl: _react.PropTypes.string,
  otherUserId: _react.PropTypes.shape({
    type: _react.PropTypes.number.isRequired,
    relatedId: _react.PropTypes.string.isRequired
  }),
  totalTaggedUsers: _react.PropTypes.number.isRequired,
  showOthers: _react.PropTypes.func.isRequired,
  openMiniProfile: _react.PropTypes.func.isRequired,
  miniProfileEnabled: _react.PropTypes.bool,
  topTaggedFeedUsers: _react.PropTypes.array,
  taggedUsersModalEnabled: _react.PropTypes.bool
};
exports.default = TagSummary;